import type zh from '../zh/shell';

/**
 * Frozen copy of the shell text the UI showed before the zh/en switch, rendered while
 * UI_I18N_ENABLED is off (gamma / prod). Do not edit the text; add a key here only when
 * zh gains one, with the text the UI would show without the switch. Delete with the flag.
 */
const shell: typeof zh = {
  notFound: 'Page not found',
  nav: {
    label: 'Main navigation',
    workspace: 'Workspace',
    skills: 'Skill Hub',
    tasks: 'Tasks',
    eval: 'Eval',
    feedback: 'Feedback',
    comingSoon: '{{label}} (coming soon)',
    closeMenu: 'Close navigation menu',
    openMenu: 'Open navigation menu',
    home: 'Rocky home',
    logoAlt: 'Rocky',
  },
  user: {
    viewingAs: 'Viewing as: {{alias}}',
    fallbackName: 'User',
  },
  popover: {
    close: 'Close',
    accountSettings: 'Account & Setting',
    backendManagement: 'Backend Management System',
    switchAgent: 'Switch Agent',
    language: '语言',
    viewAsOther: 'View as Other User',
    aliasPlaceholder: 'Enter alias...',
    go: 'Go',
    aliasInvalid: 'A login is letters, digits, dots, dashes or underscores — no spaces or @.',
    exitViewing: 'Exit viewing mode',
  },
  mobileTopBar: {
    files: 'Files',
    openChat: 'Open chat',
  },
  impersonation: {
    banner: 'Admin Viewing Mode: <strong>{{alias}}</strong>',
    exitLabel: 'Exit impersonation mode',
    exit: 'Exit',
  },
  accessGate: {
    noAccess: '当前账号 <strong>{{uid}}</strong> 暂未开通 Rocky 访问权限',
    intro:
      '<strong>Rocky 是 CMHK 的个人助理，</strong>无需复杂的安装手续，<strong>开箱即用，</strong>所有数据与 skills 预配置好，专注于适配您本人与团队的资讯与分析。（<site>https://rocky.ai.aws.dev/</site>）',
    sources: '目前已接入数据 / 外部资讯：',
    wechat: '微信公众号',
    custom: '您也可以联系我们，轻松构建适合自己团队的报告和新闻渠道并进行分发。',
    trial:
      '<strong>我们欢迎您的试用。</strong>请在<quip> Quip </quip>内填入您的 login 即可，Rocky 会在 1 个工作日内自动与您联系。 您也可以直接与我们（<strong>@tiancho</strong>, <strong>@qiuyac</strong>）取得联系。',
    slides: {
      workspace: { caption: 'Rocky 工作区', alt: 'Rocky Portal 工作区界面' },
      weekly: { caption: 'Weekly Usage & Revenue Report', alt: 'Weekly Usage & Revenue Report 示例' },
      forecast: { caption: 'Baseline Forecast Report', alt: 'Baseline Forecast Report 示例' },
    },
    footer: 'CMHK Agent Platform · Built for your team',
  },
};

export default shell;
